import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma,
  JsonDecodingException1p97qvfqhd5n3 as JsonDecodingException,
  throwInvalidFloatingPointDecoded3ghwdo6vya1kj as throwInvalidFloatingPointDecoded,
} from './JsonExceptions.mjs';
import {
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
} from './JsonNamesMap.mjs';
import { ENUM_getInstance3ph4fa6o285vr as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { JsonElementMarker395jk2pil4789 as JsonElementMarker } from './JsonElementMarker.mjs';
import { JsonTreeReader1ycreu77eikqj as JsonTreeReader } from './JsonTreeReader.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { classDiscriminator9fd3hvqsgfqq as classDiscriminator } from './Polymorphic.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MissingFieldException24tqif29emcmi as MissingFieldException,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { readPolymorphicJson7wfdzotvo8aj as readPolymorphicJson } from './TreeJsonDecoder.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus17rl43at52ays as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { missingFieldExceptionWithNewMessage2gqddjx5jxge9 as missingFieldExceptionWithNewMessage } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import {
  switchMode35g725ikhjpwv as switchMode,
  WriteMode_MAP_getInstancecqiyv70l0phh as WriteMode_MAP_getInstance,
} from './WriteMode.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  fromInt2ii0rejb1w62w as fromInt,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import {
  toUInt21lx0mz8wkp7c as toUInt,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  toUShort7yqspfnhrot4 as toUShort,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _UInt___get_data__impl__f0vqqw2j5mttix8w0l0 as _UInt___get_data__impl__f0vqqw } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { _UByte___get_data__impl__jof9qr23gcv767stjfh as _UByte___get_data__impl__jof9qr } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { _UShort___get_data__impl__g0245313795p1x5hw5 as _UShort___get_data__impl__g0245 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DiscriminatorHolderClass;
function DiscriminatorHolder() {
  if (DiscriminatorHolderClass === VOID) {
    class $ {
      constructor(discriminatorToSkip) {
        this.g2t_1 = discriminatorToSkip;
      }
    }
    initMetadataForClass($, 'DiscriminatorHolder');
    DiscriminatorHolderClass = $;
  }
  return DiscriminatorHolderClass;
}
function trySkip($this, $receiver, unknownKey) {
  if ($receiver == null)
    return false;
  if ($receiver.g2t_1 === unknownKey) {
    $receiver.g2t_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.p1r(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.h2m_1.v2s() === 4) {
    $this.h2m_1.j2r('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.j2m_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.j2m_1 === -1)) {
      hasComma = $this.h2m_1.i2t();
    }
  } else {
    $this.h2m_1.h2t(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.h2m_1.w2s()) {
    if (decodingKey) {
      if ($this.j2m_1 === -1) {
        var tmp0 = $this.h2m_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.n2m_1;
        if (!condition) {
          var tmp$ret$1 = 'Unexpected leading comma';
          tmp0.j2r(tmp$ret$1, position);
        }
      } else {
        var tmp0_0 = $this.h2m_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.n2m_1;
        if (!condition_0) {
          var tmp$ret$3 = 'Expected comma after the key-value pair';
          tmp0_0.j2r(tmp$ret$3, position_0);
        }
      }
    }
    $this.j2m_1 = $this.j2m_1 + 1 | 0;
    tmp = $this.j2m_1;
  } else {
    if (hasComma && !$this.f2m_1.a2m_1.z2n_1) {
      invalidTrailingComma($this.h2m_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.f2m_1;
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.l1p(index);
    var elementDescriptor = descriptor.k1p(index);
    var tmp;
    if (isOptional && !elementDescriptor.w1o()) {
      tmp = $this.h2m_1.j2t(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.d1p(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.w1o()) {
        tmp_0 = $this.h2m_1.j2t(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.h2m_1.k2t($this.l2m_1.n2n_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.a2m_1.q2n_1 && elementDescriptor.w1o();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.h2m_1.x2s();
        tmp$ret$0 = true;
        break $l$block_2;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.h2m_1.i2t();
  while ($this.h2m_1.w2s()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.h2m_1.h2t(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.f2m_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.l2m_1.s2n_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.h2m_1.i2t();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.m2m_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.a2r(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.f2m_1.a2m_1.z2n_1) {
    invalidTrailingComma($this.h2m_1);
  }
  var tmp1_safe_receiver = $this.m2m_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b2r();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.f2m_1) || trySkip($this, $this.k2m_1, key)) {
    $this.h2m_1.m2t($this.l2m_1.n2n_1);
  } else {
    $this.h2m_1.o2m_1.c2s();
    $this.h2m_1.l2t(key);
  }
  return $this.h2m_1.i2t();
}
function decodeListIndex($this) {
  var hasComma = $this.h2m_1.i2t();
  var tmp;
  if ($this.h2m_1.w2s()) {
    if (!($this.j2m_1 === -1) && !hasComma) {
      $this.h2m_1.j2r('Expected end of the array or comma');
    }
    $this.j2m_1 = $this.j2m_1 + 1 | 0;
    tmp = $this.j2m_1;
  } else {
    if (hasComma && !$this.f2m_1.a2m_1.z2n_1) {
      invalidTrailingComma($this.h2m_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.l2m_1.n2n_1) {
    tmp = $this.h2m_1.o2t();
  } else {
    tmp = $this.h2m_1.n2t();
  }
  return tmp;
}
var StreamingJsonDecoderClass;
function StreamingJsonDecoder() {
  if (StreamingJsonDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(json, mode, lexer, descriptor, discriminatorHolder) {
        super();
        this.f2m_1 = json;
        this.g2m_1 = mode;
        this.h2m_1 = lexer;
        this.i2m_1 = this.f2m_1.n1r();
        this.j2m_1 = -1;
        this.k2m_1 = discriminatorHolder;
        this.l2m_1 = this.f2m_1.a2m_1;
        this.m2m_1 = this.l2m_1.q2n_1 ? null : new (JsonElementMarker())(descriptor);
      }
      c2o() {
        return this.f2m_1;
      }
      n1r() {
        return this.i2m_1;
      }
      d2o() {
        return (new (JsonTreeReader())(this.f2m_1.a2m_1, this.h2m_1)).z2s();
      }
      x1q(deserializer) {
        try {
          var tmp;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp = true;
          } else {
            tmp = this.f2m_1.a2m_1.t2n_1;
          }
          if (tmp) {
            return deserializer.j1m(this);
          }
          var discriminator = classDiscriminator(deserializer.h1m(), this.f2m_1);
          var tmp0_elvis_lhs = this.h2m_1.p2t(discriminator, this.l2m_1.n2n_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            var tmp2 = isInterface(deserializer, DeserializationStrategy()) ? deserializer : THROW_CCE();
            var tmp$ret$0;
            $l$block: {
              // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
              var tmp_1;
              if (!(tmp2 instanceof AbstractPolymorphicSerializer())) {
                tmp_1 = true;
              } else {
                tmp_1 = this.c2o().a2m_1.t2n_1;
              }
              if (tmp_1) {
                tmp$ret$0 = tmp2.j1m(this);
                break $l$block;
              }
              var discriminator_0 = classDiscriminator(tmp2.h1m(), this.c2o());
              var tmp0 = this.d2o();
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName = tmp2.h1m().k1n();
              if (!(tmp0 instanceof JsonObject())) {
                var tmp_2 = getKClass(JsonObject()).j1();
                var tmp_3 = getKClassFromExpression(tmp0).j1();
                var tmp$ret$2 = this.h2m_1.o2m_1.d2s();
                throw JsonDecodingException(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(tmp0));
              }
              var jsonTree = tmp0;
              var tmp0_safe_receiver = jsonTree.h2o(discriminator_0);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
              var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
              var tmp_4;
              try {
                tmp_4 = findPolymorphicSerializer(tmp2, this, type);
              } catch ($p) {
                var tmp_5;
                if ($p instanceof SerializationException()) {
                  var it = $p;
                  throw JsonDecodingException(-1, ensureNotNull(it.message), jsonTree.toString());
                } else {
                  throw $p;
                }
              }
              var tmp_6 = tmp_4;
              var actualSerializer = isInterface(tmp_6, DeserializationStrategy()) ? tmp_6 : THROW_CCE();
              tmp$ret$0 = readPolymorphicJson(this.c2o(), discriminator_0, jsonTree, actualSerializer);
            }
            return tmp$ret$0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var type_0 = tmp_0;
          var tmp_7;
          try {
            tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
          } catch ($p) {
            var tmp_8;
            if ($p instanceof SerializationException()) {
              var it_0 = $p;
              var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
              var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
              this.h2m_1.j2r(message, VOID, hint);
            } else {
              throw $p;
            }
            tmp_7 = tmp_8;
          }
          var tmp_9 = tmp_7;
          var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy()) ? tmp_9 : THROW_CCE();
          this.k2m_1 = new (DiscriminatorHolder())(discriminator);
          return actualSerializer_0.j1m(this);
        } catch ($p) {
          if ($p instanceof MissingFieldException()) {
            var e = $p;
            if (contains(ensureNotNull(e.message), 'at path'))
              throw e;
            throw missingFieldExceptionWithNewMessage(e, plus(e.message, ' at path: ') + this.h2m_1.o2m_1.d2s());
          } else {
            throw $p;
          }
        }
      }
      y1q(descriptor) {
        var newMode = switchMode(this.f2m_1, descriptor);
        this.h2m_1.o2m_1.y2r(descriptor);
        this.h2m_1.h2t(newMode.s2t_1);
        checkLeadingComma(this);
        var tmp;
        switch (newMode.w1_1) {
          case 1:
          case 2:
          case 3:
            tmp = new (StreamingJsonDecoder())(this.f2m_1, newMode, this.h2m_1, descriptor, this.k2m_1);
            break;
          default:
            var tmp_0;
            if (this.g2m_1.equals(newMode) && this.f2m_1.a2m_1.q2n_1) {
              tmp_0 = this;
            } else {
              tmp_0 = new (StreamingJsonDecoder())(this.f2m_1, newMode, this.h2m_1, descriptor, this.k2m_1);
            }

            tmp = tmp_0;
            break;
        }
        return tmp;
      }
      z1q(descriptor) {
        if (descriptor.f1p() === 0 && ignoreUnknownKeys(descriptor, this.f2m_1)) {
          skipLeftoverElements(this, descriptor);
        }
        if (this.h2m_1.i2t() && !this.f2m_1.a2m_1.z2n_1) {
          invalidTrailingComma(this.h2m_1, '');
        }
        this.h2m_1.h2t(this.g2m_1.t2t_1);
        this.h2m_1.o2m_1.c2s();
      }
      j1q() {
        var tmp;
        var tmp0_safe_receiver = this.m2m_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z2q_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
          tmp = !this.h2m_1.u2t();
        } else {
          tmp = false;
        }
        return tmp;
      }
      k1q() {
        return null;
      }
      k1r(descriptor, index, deserializer, previousValue) {
        var isMapKey = this.g2m_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
        if (isMapKey) {
          this.h2m_1.o2m_1.b2s();
        }
        var value = super.k1r(descriptor, index, deserializer, previousValue);
        if (isMapKey) {
          this.h2m_1.o2m_1.a2s(value);
        }
        return value;
      }
      p1r(descriptor) {
        var index;
        switch (this.g2m_1.w1_1) {
          case 0:
            index = decodeObjectIndex(this, descriptor);
            break;
          case 2:
            index = decodeMapIndex(this);
            break;
          default:
            index = decodeListIndex(this);
            break;
        }
        if (!this.g2m_1.equals(WriteMode_MAP_getInstance())) {
          this.h2m_1.o2m_1.z2r(index);
        }
        return index;
      }
      l1q() {
        return this.h2m_1.v2t();
      }
      m1q() {
        var value = this.h2m_1.w2t();
        if (!(value === fromInt(convertToByte(value)))) {
          this.h2m_1.j2r("Failed to parse byte for input '" + value.toString() + "'");
        }
        return convertToByte(value);
      }
      n1q() {
        var value = this.h2m_1.w2t();
        if (!(value === fromInt(convertToShort(value)))) {
          this.h2m_1.j2r("Failed to parse short for input '" + value.toString() + "'");
        }
        return convertToShort(value);
      }
      o1q() {
        var value = this.h2m_1.w2t();
        if (!(value === fromInt(convertToInt(value)))) {
          this.h2m_1.j2r("Failed to parse int for input '" + value.toString() + "'");
        }
        return convertToInt(value);
      }
      p1q() {
        return this.h2m_1.w2t();
      }
      q1q() {
        var tmp0 = this.h2m_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2s();
          try {
            // Inline function 'kotlin.text.toFloat' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.j2r("Failed to parse type '" + 'float' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.f2m_1.a2m_1.v2n_1;
        if (specialFp || isFinite(result))
          return result;
        throwInvalidFloatingPointDecoded(this.h2m_1, result);
      }
      r1q() {
        var tmp0 = this.h2m_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2s();
          try {
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.j2r("Failed to parse type '" + 'double' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.f2m_1.a2m_1.v2n_1;
        if (specialFp || isFinite_0(result))
          return result;
        throwInvalidFloatingPointDecoded(this.h2m_1, result);
      }
      s1q() {
        var string = this.h2m_1.y2s();
        if (!(string.length === 1)) {
          this.h2m_1.j2r("Expected single char, but got '" + string + "'");
        }
        return charCodeAt(string, 0);
      }
      t1q() {
        var tmp;
        if (this.l2m_1.n2n_1) {
          tmp = this.h2m_1.o2t();
        } else {
          tmp = this.h2m_1.x2s();
        }
        return tmp;
      }
      v1q(descriptor) {
        return get_isUnsignedNumber(descriptor) ? new (JsonDecoderForUnsignedTypes())(this.h2m_1, this.f2m_1) : super.v1q(descriptor);
      }
      u1q(enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.f2m_1, this.t1q(), ' at path ' + this.h2m_1.o2m_1.d2s());
      }
    }
    initMetadataForClass($, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder()]);
    StreamingJsonDecoderClass = $;
  }
  return StreamingJsonDecoderClass;
}
var JsonDecoderForUnsignedTypesClass;
function JsonDecoderForUnsignedTypes() {
  if (JsonDecoderForUnsignedTypesClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(lexer, json) {
        super();
        this.x2t_1 = lexer;
        this.y2t_1 = json.n1r();
      }
      n1r() {
        return this.y2t_1;
      }
      p1r(descriptor) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o(toString(message));
      }
      o1q() {
        var tmp0 = this.x2t_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2s();
          try {
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = toUInt(input);
            tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.j2r("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      p1q() {
        var tmp0 = this.x2t_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2s();
          try {
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = toULong(input);
            tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.j2r("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      m1q() {
        var tmp0 = this.x2t_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2s();
          try {
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = toUByte(input);
            tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.j2r("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      n1q() {
        var tmp0 = this.x2t_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.y2s();
          try {
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = toUShort(input);
            tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.j2r("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'JsonDecoderForUnsignedTypes');
    JsonDecoderForUnsignedTypesClass = $;
  }
  return JsonDecoderForUnsignedTypesClass;
}
//region block: exports
export {
  JsonDecoderForUnsignedTypes as JsonDecoderForUnsignedTypesaowwj2t4rf8t,
  StreamingJsonDecoder as StreamingJsonDecoderyo05rsghf9i6,
};
//endregion

//# sourceMappingURL=StreamingJsonDecoder.mjs.map
